<template>
  <div :id="data? data.url: ''" class="page">
    <template v-if="!loading">
      <Banner :banner="page.banner" />
      <section class="container py-4 bg-white text-left">
        <Breadcrumb :items="breadcrumb" />
        <div class="row">
          <div
            v-if="($route.name !== 'donate_asiapay' && $route.name !== 'donate_alipay')"
            class="col-lg-3"
          >
            <div class="d-flex align-items-center donate_contact py-4">
              <div class="w-100">
                <b-link
                  class="donate_contact_link"
                  :to="page.link_info? page.link_info.url: '/donate/form'"
                >
                  <!-- <img
                    v-if="page.link_info && page.link_info.image"
                    :src="page.link_info.image"
                    class="mb-4"
                  />-->
                  <div
                    class="donate_contact_logo"
                    v-if="page.link_info && page.link_info.image"
                    :style="{ backgroundImage: 'url(' + page.link_info.image + ')' }"
                  ></div>
                  <img :src="getAssetLink('/assets/media/donate/donation_contact.png')" />
                </b-link>
              </div>
            </div>
          </div>
          <div
            :class="($route.name === 'donate_asiapay' || $route.name === 'donate_alipay')? 'col-lg-12': 'col-lg-9'"
          >
            <div class="content">
              <div v-if="!loading && data" class="articleBodyFullWidth">
                <div class="articleContent">
                  <template v-if="data.form">
                    <template v-if="$route.name === 'donate_asiapay'">
                      <div class="hint_msg">{{ $t('component.donate.asiapay_hint') }}</div>
                      <div class="loader my-5" />
                      <Form
                        :form="data.form"
                        v-bind="$route.name === 'donate_asiapay'? { action: asiapay_url, auto_submit: true, class: 'd-none'}: { url: path}"
                      />
                    </template>
                    <template v-else>
                      <div
                        v-if="data.body"
                        v-lazy-container="{ selector: 'img' }"
                        class="mb-3"
                        v-html="filterHTML(data.body)"
                      />
                      <div
                        v-if="page.link_info"
                        class="font-weight-bold text-danger"
                        v-html="page.link_info.message_show"
                      />
                      <Form :form="data.form" :url="data.form.url" />
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="data.body">
                      <div v-if="$route.name ==='donate_thankyou'" class="mb-3">
                        <div v-lazy-container="{ selector: 'img' }" v-html="filterHTML(data.body)" />
                        <h4>{{ $route.query.Ref }}</h4>
                        <p>
                          <strong>{{ $t("component.donate.print_desc") }}</strong>
                        </p>
                        <input
                          type="button"
                          class="btn btn-primary mt-2 btn-sm"
                          name="printButton"
                          :value="$t('component.donate.print_btn')"
                          onclick="window.print()"
                        />
                      </div>
                      <div
                        v-else
                        v-lazy-container="{ selector: 'img' }"
                        class="mb-3"
                        v-html="filterHTML(data.body)"
                      />
                    </template>
                    <div v-else-if="data.payment_url" class="qrcode_container">
                      <div class="donation-right">
                        <div id="alipay-wrapper">
                          <h3>Scan code with AlipayHK app to pay</h3>
                          <div>
                            Total Amount:
                            <strong style="color: #f38413;font-size:20px;">
                              {{ data.donate_amount }}
                              <small style="font-size: 50%;">HKD</small>
                            </strong>
                          </div>
                          <div id="qrcode-wrapper">
                            <div id="qrcode">
                              <iframe :src="data.payment_url" width="300" height="300" />
                            </div>
                          </div>
                          <b-link id="cancel_link" :href="data.cancel_url">&lt; Cancel and return</b-link>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>
<script>
import Banner from "@/components/Banner.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Form from "@/components/Form.vue";

export default {
  name: "Donate",
  components: {
    Banner,
    Breadcrumb,
    Form
  },
  data() {
    return {
      path: this.$router.history.current.path.substr(1),
      loading: true,
      page: null,
      data: null,
      breadcrumb: [],
      count: 0,
      asiapay_url: process.env.VUE_APP_ASIAPAY_API
    };
  },
  watch: {
    $route(to) {
      this.path = to.path.substr(1);
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    checkPayment() {
      // Terminate checking if redirect from /donate/alipay to other pages
      if (
        this.$route.name != "donate_alipay" ||
        this.getDeviceType() != "web"
      ) {
        return;
      }
      var that = this;
      that.count++;
      // if (that.count <= 60) {
      that.$http
        .post(that.data.check_status_url, {
          count: that.count,
          hash: that.data.hash
        })
        .then(response => {
          // if (response.data.success) {
          if (response.data.redirect && response.data.redirect.url) {
            // location.href = response.data.redirect.url;
            that.$router.push(that.replaceDomain(response.data.redirect.url));
            // }
          } else {
            setTimeout(function() {
              that.checkPayment();
            }, 1000);
          }
        });
      // } else {
      //   location.href = this.$router.replace(this.data.cancel_url);
      // }
    },
    getDeviceType() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return "mobile";
      }
      return "web";
    },
    replaceDomain(content) {
      content = content.replace("http://web-oscdev.scmp.com", "");
      content = content.replace("http://web-oscuat.scmp.com", "");
      return content;
    },
    init() {
      this.loading = true;

      this.page = {
        // Default Settings for page
        sidemenu: null,
        banner: null,
        title: this.$t("page." + this.path),
        heading: null
      };

      let path = this.path;
      let params = {};
      switch (this.$route.name) {
        // case "donate":
        case "donate_form":
          // params = this.$route.query;
          // this.getPageInfo("donate/form", params);
          this.getPageInfo("donate/form");
          break;
        case "donate_thankyou":
        case "donate_transaction_error":
          if (!this.$route.query.Ref || this.$route.query.Ref === "") {
            this.$router.replace(
              this.$route.params.company != undefined
                ? "/donate/form/" + this.$route.params.company
                : "/donate/form"
            );
            return;
          }
          if (this.$route.params.company != undefined) {
            path = path.replace(this.$route.params.company, "");
            this.$http
              .get("/donate/link/" + this.$route.params.company)
              .then(response => {
                if (response.data.success) {
                  let data = response.data.data;
                  this.page.link_info = this.getLinkInfo(data);
                  this.getPageInfo(path);
                } else throw { response: response };
              })
              .catch(error => {
                this.handleFailedRequest(error.response);
              })
              .finally(() => {});
          } else {
            this.getPageInfo(path);
          }
          break;
        case "donate_alipay":
          if (!this.$route.query.Ref || this.$route.query.Ref === "") {
            this.$router.replace(
              this.$route.params.company != undefined
                ? "/donate/form/" + this.$route.params.company
                : "/donate/form"
            );
            return;
          }
          params = this.$route.query;
          params["device"] = this.getDeviceType();
          this.getPageInfo(path, params);
          break;
        default:
          params = this.$route.query;
          this.getPageInfo(path, params);
          break;
      }
    },
    getPageInfo(path, params = null) {
      // Get Page Info
      this.$http
        .get(path, { params: params })
        .then(response => {
          if (response.data.success) {
            this.data = response.data.data;

            if (this.data.type === "page") {
              this.page.banner = this.data.image;
            }
            this.page.title =
              this.getDataValue("name", this.data) || this.page.title;
            this.page.heading =
              this.getDataValue("headline", this.data) || this.page.heading;
            this.$route.meta.title = this.page.title;
            this.$route.meta.desc = this.data.desc;

            // TEMP
            if (process.env.NODE_ENV === "development") {
              if (this.data.body) {
                this.data.body = this.replaceDomain(this.data.body);
              }
            }
          } else throw { response: response };
        })
        .catch(error => {
          this.handleFailedRequest(error.response);
        })
        .finally(() => {
          this.loading = false;
          // Get Form
          if (this.$route.name === "donate_form") {
            this.getForm().finally(() => {
              this.updateMeta();
            });
          } else if (this.$route.name === "donate_alipay") {
            let device = this.getDeviceType();
            this.count = 0; // Reset count
            if (device === "mobile") {
              location.href = this.data.payment_url;
              return;
            } else {
              this.checkPayment();
            }
          } else {
            this.updateMeta();
          }
        });
    },
    updateMeta() {
      this.breadcrumb = [];
      this.breadcrumb.push({
        name: this.$t("page.donate"),
        url: "/donate"
      });
      if (this.page.link_info && this.page.link_info.url) {
        this.breadcrumb.push({
          name: this.$t("page.donate_form"),
          url: this.page.link_info.url
        });
      }
      this.$meta().refresh(); // Important!
    },
    handleFailedRequest(response) {
      let data = response.data;
      if (data.redirect && data.redirect.url) {
        this.$router.push(data.redirect.url);
      }
      // if (response && (response.status ==== 404 || response.status ==== 401))
      else {
        this.$router.push("/donate");
      }
      // else if (typeof data === "string") {
      //   throw new Error(data);
      // } else {
      //   throw new Error(data.error);
      // }
    },
    getLinkInfo(data) {
      let image = data.image ? this.getAssetLink(data.image) : null;
      let link_info = {
        link_id: data.link_id,
        image: image,
        message_show: data.message_show,
        url: data.url === "osc" ? "/donate/form" : "/donate/form/" + data.url
      };
      return link_info;
    },
    getForm() {
      let form_url =
        this.$route.params.company != undefined
          ? "/donate/forms/" + this.$route.params.company
          : "/donate/forms"; // Get form detail, different from /donate/form
      return this.$http
        .get(form_url)
        .then(response => {
          if (response.data.success) {
            let data = response.data.data;
            let form = data.form;
            form.form_name = null;
            if (data.amount) {
              form.fields = data.amount.concat(form.fields);
            }
            form.url = form_url;
            this.data.form = form; // Hide Form Name
            this.page.link_info = this.getLinkInfo(data);
          } else throw { response: response };
        })
        .catch(error => {
          this.handleFailedRequest(error.response);
        });
    }
  }
};
</script>
<style scoped lang="scss" src="../assets/scss/donate.scss"></style>
